module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.store.state.currentNeighborhood),
      expression: "store.state.currentNeighborhood"
    }],
    staticClass: "streetview",
    attrs: {
      "id": "streetview"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.store.state.currentNeighborhood) + " from Street View")]), _vm._v(" "), _vm._l((_vm.streetViewPhotos.slice(0, 20)), function(url) {
    return _c('span', [_c('a', {
      attrs: {
        "href": url
      }
    }, [_c('img', {
      staticClass: "preview_photo",
      attrs: {
        "src": url
      }
    })])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-372667a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StreetView.vue
// module id = 176
// module chunks = 1